import {
  SET_BRANDING_THEME,
  SET_SHARES_LOGO_STORED_FILE_UUID,
} from './branding.actions';

export interface IBrandingState {
  isFetching: boolean;
  sharesAllowIndexing: boolean;
  sharesAllowPrint: boolean;
  sharesLogoStoredFileUUID: string;
  sharesLogoPosition: string;
  sharesLogoLink: string;
  sharesFaviconStoredFileUUID: string;
  sharesCoverStoredFileUUID: string;
  sharesTopbar: boolean;
  sharesCopyBlotLinkIcon: boolean;
  sharesFullscreen: boolean;
  sharesShareButton: boolean;
  sharesShowDate: boolean;
  sharesOutliner: boolean;
  theme: string;
}

export const brandingInitialState: IBrandingState = {
  isFetching: true,
  sharesAllowIndexing: false,
  sharesAllowPrint: true,
  sharesLogoStoredFileUUID: null,
  sharesLogoPosition: 'left',
  sharesLogoLink: null,
  sharesFaviconStoredFileUUID: null,
  sharesCoverStoredFileUUID: null,
  sharesTopbar: true,
  sharesCopyBlotLinkIcon: true,
  sharesFullscreen: true,
  sharesShareButton: true,
  sharesShowDate: false,
  sharesOutliner: true,
  theme: 'day',
};

export function brandingReducer(state = brandingInitialState, action) {
  switch (action.type) {
    case SET_BRANDING_THEME:
      return Object.assign({}, state, {isFetching: false}, action.value);
    case SET_SHARES_LOGO_STORED_FILE_UUID:
      return Object.assign({}, state, {sharesLogoStoredFileUUID: action.value});

    default:
      return state;
  }
}
